module.exports = __webpack_public_path__ + "1fcfc97704640919f1eb2931a5d21d80.png";